import React, { useState } from 'react';
import { attachmentPreviewPropTypes } from '../../../../utils/attachments';
import { StyledImage, StyledEnlarger } from './styles';

const ImageMessageAttachment = ({ assetLocalUrl, title }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <>
      <StyledImage
        src={assetLocalUrl}
        alt={title}
        onClick={() => setIsFullscreen(true)}
      />
      <StyledEnlarger
        open={isFullscreen}
        onClose={() => setIsFullscreen(false)}
        onClick={() => setIsFullscreen(false)}
        placement="left-end"
      >
        <img
          src={assetLocalUrl}
          alt={title}
        />
      </StyledEnlarger>
    </>
  );
};

ImageMessageAttachment.propTypes = attachmentPreviewPropTypes;

ImageMessageAttachment.defaultProps = {};

export default ImageMessageAttachment;
